import axios from 'axios'
import ls from 'local-storage'

const UPDATE_LIST = 'updatelist'    // https://member.chachadaily.com/updatelist.html
const STORES_LIST = 'maplist'       // https://member.chachadaily.com/maplist.html
const PRODUCT_LIST = 'productlist'  // https://member.chachadaily.com/productlist.html
const BRIDGE_LIST = 'matchlist'     // https://member.chachadaily.com/matchlist.html

const https = axios.create({
  baseURL: 'https://member.chachadaily.com',
})

export const preflight = async () => {
  const { data: newUpdateTime } = await https.get(`/${UPDATE_LIST}.html`)
  const lastUpdateTime = ls.get(UPDATE_LIST)

  const status = {
    isStoreListOutdated: true,
    isProductListOutdated: true,
    isBridgeListOutdated: true
  }

  if (lastUpdateTime) {
    status.isStoreListOutdated = newUpdateTime.map !== lastUpdateTime.map
    status.isProductListOutdated = newUpdateTime.product !== lastUpdateTime.product
    status.isBridgeListOutdated = newUpdateTime.match !== lastUpdateTime.match
  }

  ls.set(UPDATE_LIST, newUpdateTime)
  return status
}

export const getter = async (storageId, isOutdated) => {
  if (isOutdated) {
    const { data } = await https.get(`/${storageId}.html`)
    ls.set(storageId, data)
    return data
  }
  return ls.get(storageId)
}

export const loader = async (status) => {
  const storeList = getter(STORES_LIST, status.isStoreListOutdated)
  const productList = getter(PRODUCT_LIST, status.isProductListOutdated)
  const bridgeList = getter(BRIDGE_LIST, status.isBridgeListOutdated)

  return await Promise.all([storeList, productList, bridgeList])
}

export const data = async () => {
  const dataStatus = await preflight()
  return await loader(dataStatus)
}